module.exports = __webpack_public_path__ + "static/media/img1.f5ae123a.jpg";